export type CheckinStatus =
	| "QUEUED"
	| "REVIEW"
	| "INVITED"
	| "DISMISSED"
	| "SKIPPED"
	| "WAITING"

type BadgeVariant = "important" | "green" | "light-gray" | "default"

const STATUS_VIEW: Record<
	CheckinStatus,
	{ label: string; badge: BadgeVariant }
> = {
	REVIEW: { label: "Review", badge: "important" },
	WAITING: { label: "Waiting", badge: "default" },
	QUEUED: { label: "Queued", badge: "green" },
	INVITED: { label: "Invited", badge: "green" },
	SKIPPED: { label: "Skipped", badge: "light-gray" },
	DISMISSED: { label: "Dismissed", badge: "light-gray" },
}

export function statusView(status: CheckinStatus) {
	return STATUS_VIEW[status]
}

export function canReview(row: { status: CheckinStatus }): boolean {
	return row.status === "REVIEW" || row.status === "SKIPPED"
}

export function linkedinSlug(url: string): string {
	return url
		.replace(/^https:\/\/(www\.)?linkedin\.com\/in\//, "")
		.replace(/\/$/, "")
}

export function isOpen(row: { status: CheckinStatus }): boolean {
	return row.status === "REVIEW" || row.status === "WAITING"
}
